// Small formatting helpers for UI presentation.

import { format } from "date-fns";

/**
 * Format a distance in metres into a short human-readable string.
 * Examples: 250 -> "250 m away", 1530 -> "1.5 km away"
 */
export function formatDistance(metres?: number | null): string {
  if (typeof metres !== "number" || !Number.isFinite(metres) || metres < 0)
    return "";
  if (metres < 1000) return `${Math.round(metres)} m away`;
  const km = metres / 1000;
  const value = km < 10 ? km.toFixed(1) : Math.round(km).toString();
  return `${value} km away`;
}

/**
 * Format a date and time for display.
 */
export function formatDateTime(date: Date): string {
  return format(date, "PPpp");
}

/**
 * Format a date and time for short display.
 */
export function formatDateTimeShort(date: Date): string {
  return format(date, "PPp");
}

/**
 * Format text for display by replacing underscores with spaces.
 */
export function formatDisplayText(text: string): string {
  return text.replace(/_/g, " ");
}

/**
 * Format role text for display by replacing underscores with spaces.
 */
export function formatRoleText(role: string): string {
  return role.replace(/_/g, " ");
}

/**
 * Format action text for display by replacing underscores with spaces.
 */
export function formatActionText(action: string): string {
  return action.replace(/_/g, " ");
}
